<template>
	<b-container fluid class="m-0 p-1">
		<el-tabs type="border-card" tab-position="top" class="mt-1" v-if="status !== 'RUNNING'">
			<el-tab-pane label="Sample Data">
				<b-row class="p-0 m-0">
					<b-col class="d-flex justify-content-end p-0">
						<span class="d-inline-flex p-1">
							<b-form-select id="per-page-select" v-model="table.rowsPerPage">
								<b-form-select-option :value="10">10</b-form-select-option>
								<b-form-select-option :value="20">20</b-form-select-option>
								<b-form-select-option :value="50">50</b-form-select-option>
								<b-form-select-option :value="100">100</b-form-select-option>
							</b-form-select>
						</span>
						<span class="d-inline-flex p-1">
							<b-pagination variant="outline-secondary" v-model="table.pageNo" :total-rows="table.totalRows" :per-page="table.rowsPerPage"/>
						</span>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-table v-if="status ==='SUCCESS'" head-variant="light" no-border-collapse bordered striped hover small sticky-header :items="table.data" :fields="table.fields" :current-page="table.pageNo" :per-page="table.rowsPerPage"/>
					</b-col>
				</b-row>
			</el-tab-pane>
			<el-tab-pane label="Columns">
				<b-row class="p-0 m-0">
					<b-col class="d-flex justify-content-end p-0">
						<span class="d-inline-flex p-1">
							<b-form-select id="per-page-select" v-model="columns.rowsPerPage">
								<b-form-select-option :value="10">10</b-form-select-option>
								<b-form-select-option :value="20">20</b-form-select-option>
								<b-form-select-option :value="50">50</b-form-select-option>
								<b-form-select-option :value="100">100</b-form-select-option>
							</b-form-select>
						</span>
						<span class="d-inline-flex p-1">
							<b-pagination variant="outline-secondary" v-model="columns.pageNo" :total-rows="columns.totalRows" :per-page="columns.rowsPerPage"/>
						</span>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-table v-if="status ==='SUCCESS'" head-variant="light" responsive bordered striped hover  sticky-header :items="columns.data" :fields="columns.fields" :current-page="columns.pageNo" :per-page="columns.rowsPerPage"/>
					</b-col>
				</b-row>
			</el-tab-pane>
			<el-tab-pane label="Script" style="height: 260px; overflow: auto">
				<div class="d-flex">
					<a-code-editor v-model="createTableScript" lineNumbers readonly class="m-0 p-0"></a-code-editor>
				</div>
			</el-tab-pane>
		</el-tabs>
	</b-container>
</template>

<script>
import {HTTP} from '../services/HttpService'
export default {
  name: 'table-info',
  props: {
    tab: Object
  },
  data () {
    return {
      status: 'RUNNING',
      createTableScript: '',
      rowsCount: 0,
      table: {
        fields: [],
        data: [],
        pageNo: 1,
        totalRows: 0,
        rowsPerPage: 20
      },
      columns: {
        fields: [{
          key: 'name',
          label: 'Column Name',
          headerTitle: 'Column Name',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-left'
        }, {
          key: 'dataTypeText',
          label: 'Data Type',
          headerTitle: 'Data Type',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-left'
        }, {
          key: 'columnSize',
          label: 'Size',
          headerTitle: 'Size',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-right'
        }, {
          key: 'decimalSize',
          label: 'Precision',
          headerTitle: 'Precision',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-right'
        }
        ],
        data: [],
        pageNo: 1,
        totalRows: 0,
        rowsPerPage: 20
      }
    }
  },
  mounted: function () {
  },
  methods: {
    getTableDetails () {
      console.log(this.tab)
      console.log('Executing Query for TAB: ' + this.tab.id)
      this.table.status = 'Running'
      HTTP.get('api/metadata/catalogs/123/schemas/123/tables/' + this.tab.tableId)
        .then(response => {
          console.log('Processing response')
          var result = response.data
          var tableData = []
          console.log('Setting table data')
          for (var row of result.data) {
            var tableRow = {}
            for (var cell in row) {
              var key = result.columns[cell].name
              var value = row[cell]
              tableRow[key] = value
            }
            // console.log(tableRow)
            tableData.push(tableRow)
          }
          var fields = []
          for (var column of result.columns) {
            let tdClass = 'text-nowrap'
            switch (column.dataTypeText) {
              case 'INTEGER':
              case 'BIGINT':
              case 'DOUBLE':
              case 'FLOAT':
              case 'DECIMAL':
                tdClass += ' text-right'
                break
              case 'TIMESTAMP':
              case 'DATE':
                tdClass += ' text-center'
                break
            }
            var field = {
              key: column.name,
              label: column.name,
              headerTitle: column.name,
              sortable: true,
              thClass: 'text-center',
              tdClass: tdClass
            }
            fields.push(field)
          }
          this.table.fields = fields
          this.table.totalRows = tableData.length
          this.table.data = tableData
          // setting the columns table
          this.columns.data = result.columns
          this.columns.totalRows = result.columns.length
          this.tab.status = 'Done'
          this.status = 'SUCCESS'
          this.createTableScript = result.createTableScript
          this.$emit('onComplete', this.tab.id)
        })
    }
  },
  created () {
    this.getTableDetails()
  }
}
</script>

<style>
.el-tabs--border-card>.el-tabs__content {
    /* padding: 15px; */
}
</style>



// WEBPACK FOOTER //
// TableInfo.vue?78fb2a96